
import { Component, ElementRef, AfterViewInit } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { GeneralHelpDTO, GeneralHelpGroupDTO, GeneralHelpGroupContentsDTO, HelpElementDTO } from './help.dtos';
import { UIService } from '../../../ui.service';
import { PlycaDataService } from '../../../../services/plyca.service';
import { TreeNode } from 'primeng-lts/api';
import { Configuration } from '../../../conf/app.constants';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../../../ServiceLocator';
import { HelpService, HelpType } from '../../../components/common/help/help.service';
import { HeaderActionsService } from '../sub-header/header-actions.service';
import { UserService } from '../../../user.service';
import { HelpDeskDTO } from '../../../api/plyca-dtos-v2';
import { finalize } from 'rxjs/operators';
import { WaitLoadingService } from '../waitLoading/wait-loading.service';
import { BaseComponent } from '../baseComponent/base.component';
import { Router } from '@angular/router';


@Component({
  selector: 'plyca-generalHelp',
  templateUrl: 'generalHelp.template.html'
})
export class GeneralHelpComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  loaded = false;
  helpContent: any;
  selectedHelp: any;
  public translate: TranslateService;
  public locale: string;

  helperOptions: Array<HelpDeskDTO>;


  constructor(
    public uiService: UIService,
    public plycaService: PlycaDataService,
    public userService: UserService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    public configuration: Configuration,
    private elem: ElementRef,
    private waitService: WaitLoadingService,
    private router: Router
  ) {
    super();

    this.subscribe(this.helpService.showContextHelpObservable(HelpType.GENERAL_HELP));
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.locale = this.translate.currentLang;
  }

  ngOnInit() {
    this.waitService.startWaiting();

    let obs1 = this.plycaService.query<any>(this.configuration.HELP_SERVICE_URL, {
      locale: this.locale,
    });

    let obs2 = this.plycaService.query<any>(
      this.configuration.HELPDESK_SERVICE_URL
    );

    this.subscribe(
      forkJoin([obs1, obs2]).pipe(

        finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        }
        )),
      (result: any[]) => {


        try {
          if (result[0] && result[0].content) {
            // this.dto2TreeModel(result[0]);

            this.dto2TreeModel(result[0]);

            // Expandir el primer elemento
            if (!this.helpContent || !this.helpContent[0] || !this.helpContent[0].expanded) {
              this.helpContent[0].expanded = true;
            }
            this.selectedHelp = this.helpContent && this.helpContent[0] ? this.helpContent[0] : null;
            this.selectedHelp = this.helpContent && this.helpContent[0]
              && this.helpContent[0].children && this.helpContent[0].children[0] ? this.helpContent[0] : null;

          }
        } catch (e) {
          console.log(e);
        }
        try {
          if (result[1]) {
            this.helperOptions = result[1];
          }

        } catch (e) {
          console.log(e);
        }

      }


    );

  }
  ngAfterViewInit(): void {
    this.headerActionsService.setTaskDescription(this.elem, 'General.ayuda', 'fas fa-question', true);
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });

  }

  ngOnDestroy() {
    this.uiService = null;

    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  isLoaded() {
    return this.loaded;
  }

  group2Node(group: GeneralHelpGroupContentsDTO, label?: string): TreeNode {
    return {
      label: label ? label : 'Plyca-Expedientes',
      data: group,
      expandedIcon: 'far fa-folder-open',
      collapsedIcon: 'far fa-folder',
      expanded: false,
      children: this.groupElements2Array(group.content)
    };
  }

  subGroup2Node(label: string): TreeNode {
    return {
      label: label,
      data: { content: [] },
      expandedIcon: 'far fa-folder-open',
      collapsedIcon: 'far fa-folder',
      expanded: false,
      children: []
    };
  }

  element2Node(element: GeneralHelpGroupDTO) {

    let filteredElements = element.content.filter(
      hl =>
        !hl.profiles
        || hl.profiles.length === 0
        || this.userService.hasRoles(hl.profiles.join(', '))

    );
    element.content = filteredElements;
    return {
      label: element.name,
      data: element,
      expandedIcon: 'far fa-folder-open',
      collapsedIcon: 'fas fa-file-alt'
    };
  }

  groupElements2Array(elements: Array<GeneralHelpGroupDTO>): Array<TreeNode> {
    let resp: Array<TreeNode> = [];
    if (elements) {
      elements.forEach(el => {
        resp.push(this.element2Node(el));
      });
    }
    return resp;
  }

  cleanGroupPath(node: TreeNode) {
    if (node.label.includes('>')) {
      node.label = node.label.substring(node.label.lastIndexOf('>') + 1);
    }
    if (node.data?.description && node.data.description.includes('>')) {
      node.data.description = node.data.description.substring(node.data.description.lastIndexOf('>') + 1);
    }
    if (node.data?.name && node.data.name.includes('>')) {
      node.data.name = node.data.name.substring(node.data.name.lastIndexOf('>') + 1);
    }
    if (node.children) {
      node.children.forEach((child: TreeNode) => {
        this.cleanGroupPath(child);
      });
    }
  }

  searchTreeNode(node: TreeNode, searchTerm: string): TreeNode | null {
    if (node.label === searchTerm) {
      return node;
    }

    if (node.children) {
      for (let child of node.children) {
        let result = this.searchTreeNode(child, searchTerm);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  addContent2Group(group: GeneralHelpGroupDTO, node: TreeNode) {
    let g: TreeNode = this.element2Node(group);
    // Se eliminan los grupos sin contenido
    if (g.data && g.data.content && g.data.content.length > 0) {
      node.children.push(g);
      node.data.content.push(group.content);
    }
  }

  dto2TreeModel(dto: GeneralHelpDTO) {
    let _helpContent: TreeNode[] = [];
    _helpContent['data'] = [];
    let levelGroups: string[] = [];
    dto.content.forEach((group: GeneralHelpGroupContentsDTO) => {
      group.content.sort((a, b) =>
        //Ordenamos primero por orderStr y despues por nombre
        (this.uiService.normalizeString(a.orderStr ? a.orderStr : "ZZZZ") > this.uiService.normalizeString(b.orderStr ? b.orderStr : "ZZZZ")) ? 1
          : (this.uiService.normalizeString(b.orderStr ? b.orderStr : "ZZZZ") > this.uiService.normalizeString(a.orderStr ? a.orderStr : "ZZZZ")) ? -1
            : ((this.uiService.normalizeString(a.name) > this.uiService.normalizeString(b.name)) ? 1
              : (this.uiService.normalizeString(b.name) > this.uiService.normalizeString(a.name))
                ? -1 : 0)
      );
      group.content.forEach((entry: GeneralHelpGroupDTO) => {
        entry.content.sort((a, b) =>
          //Ordenacion entradas dentro de los grupos
          (this.uiService.normalizeString(a.orderStr ? a.orderStr : "ZZZZ") > this.uiService.normalizeString(b.orderStr ? b.orderStr : "ZZZZ")) ? 1
            : (this.uiService.normalizeString(b.orderStr ? b.orderStr : "ZZZZ") > this.uiService.normalizeString(a.orderStr ? a.orderStr : "ZZZZ")) ? -1
              : ((this.uiService.normalizeString(a.name) > this.uiService.normalizeString(b.name)) ? 1
                : (this.uiService.normalizeString(b.name) > this.uiService.normalizeString(a.name))
                  ? -1 : 0)
        );
        if (entry.name.includes('>') && !entry['ignore']) {
          let groupLabel: string = entry.name.substring(0, entry.name.indexOf('>'));
          let SubGroupLabel: string = entry.name.substring(groupLabel.length + 1);
          let upperLevelNode: TreeNode = _helpContent.filter(e => e.label == groupLabel)[0];
          if (!upperLevelNode) {
            upperLevelNode = this.subGroup2Node(groupLabel);
            _helpContent.push(upperLevelNode);
          }
          if (SubGroupLabel.includes('>')) {
            const subGroupsLabels: string[] = SubGroupLabel.split(">");
            //Iteramos entre los subgrupos
            for (const aGroupLabel of subGroupsLabels.slice(0, -1)) {
              let foundNode = this.searchTreeNode(upperLevelNode, aGroupLabel);
              if (!foundNode) {
                let newNode = this.subGroup2Node(aGroupLabel);
                upperLevelNode.children.push(newNode);
                upperLevelNode = newNode;
              } else {
                upperLevelNode = foundNode;
              }
            }
          }
          if (levelGroups.filter(e => e == entry.name).length == 0) {
            levelGroups.push(entry.name);
            this.addContent2Group(entry, upperLevelNode);
          }
        } else if (!entry['ignore'] && entry.name && entry.name !== '') {
          let ele = this.element2Node(entry);
          if (ele.data && ele.data.content && ele.data.content.length > 0) {
            _helpContent.push(ele);
          }
        }
      });
    });
    _helpContent.forEach((node: TreeNode) => {
      this.cleanGroupPath(node);
    });
    this.helpContent = _helpContent;
  }

  print(): void {

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    printContents = printContents.replaceAll('/generalHelp%23', '');
    const stylesHtml = this.getTagsHtml('style');
    const linksHtml = this.getTagsHtml('link');
    popupWin = window.open('', '_print-window', 'top=0,left=0,height=80%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
        <head>
          <title>TITULO</title>
          ${linksHtml}
          <style>
            @media print {
              body {
              margin-top: 2cm !important;
              margin-bottom: 2cm !important;
              margin-left: 2cm !important;
              margin-right: 2cm !important;
              }
            }
          </style>
          ${stylesHtml}
        </head>
    <body onload="window.print();window.close()">
      <div class="container-fluid">
      <div class="row">
      <div class="col-12">
      <div class="ui-editor-content ql-container ql-snow ql-disabled">${printContents}</div>
      </div>
      </div>
      </div>
    </body>
    </html>`);




    popupWin.document.close();
  }

  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join('\r\n');
  }

  isQuestion(type: string) {
    return type === 'QUESTION';
  }

  isError(type: string) {
    return type === 'ERROR';
  }

  isImprovement(type: string) {
    return type === 'IMPROVEMENT';
  }

  isList(type: string) {
    return type === 'LIST';
  }

  openUrl(url: any) {
    window.open(url, '_blank', 'fullscreen=yes');
  }

  isFolder(node: TreeNode) {
    return node['children'] && node['children'].length > 0;
  }

  isIndexNeeded(node: TreeNode) {
    return node && node.data.content.length > 1;
  }

  hasContent(node: TreeNode) {
    return node && node.data.content.length > 0;
  }

  resetScroll() {
    window.scrollTo(0, 0);
  }

  onGotoElement(identifier: string): void {
    this.router.navigate(['/generalHelp'], { fragment: identifier }).then(() => {
      const scrollToElement = () => {
        const domElement = document.getElementById(identifier);
        if (domElement) {
          const y = domElement.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } else {
          requestAnimationFrame(scrollToElement);
        }
      };
      requestAnimationFrame(scrollToElement);
    });
  }
}
